import content from './content';
let {PromotionTileIndexer, TwitchConfig} = content.classes;
export default async function (view, params, repo) {
  let content = {};
  switch (view) {
	  case 'twitch':
      content.twitchConfig = await TwitchConfig.get(repo);
    break;
    case 'home':
    break;
    case 'news':
	    content.promotionTiles = await PromotionTileIndexer.get(repo);
    break;
  }

  return content;
}



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/loader.js